// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"b193debd","435":"236c52b0","453":"9c95cb4c","723":"a21ea53c","870":"c1207a98","967":"d7f532b0"}[chunkId] + ".chunk.js";
};